import { render } from "./2Factor.vue?vue&type=template&id=d1ea0674"
import script from "./2Factor.vue?vue&type=script&lang=js"
export * from "./2Factor.vue?vue&type=script&lang=js"

import "./2Factor.vue?vue&type=style&index=0&id=d1ea0674&lang=css"

import exportComponent from "/codebuild/output/src190712979/src/admin-wallet-v2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__